/*global ViewController, WebView*/

var notifySendLinkController = new ViewController(
    {
        directory: "views/notifyLinkSend",
        name: "notifyLinkSendPopup",
        route: "notifyLinkSend",
        openInPopup: true,
        noTitle: false,
        popup: {
            title: WebView.tr("linkSend.titlePopup"),
            size: "wide"
        },
        defaultData: {
            recipient_ids: [],
        }
    }
);

notifySendLinkController.prepareDataOnEnter = function (data, callback) {
    this.api.db.multiread({
        iz_link_send: {
            search: {
                user_id: this.api.currentUser.id
            },
            orderBy: "create_date desc",
            joinFetch: [
                { otherTable : "iz_user_list", name: "sender", thisField: "create_uid", otherField: "id"}
            ]
        }
    }, function (err, reads) {
        if (err) { return callback(err); }
        callback(null, {
            newLinkSend: data.linkSend,
            links: reads.iz_link_send
        });
    });
};

notifySendLinkController.onOpenLink = function (ev) {
    this.view.longTask(function (done) {
        this.api.db.transactionalChanges([
            {
                table: "iz_link_send",
                action: "update",
                record: {
                    id: ev.data.data.id,
                    state: "received"
                }
            }
        ], function (err) {
            if (err) { return done(err); }
            window.location.href = ev.data.data.url;
            done();
        });
    }.bind(this));
};

notifySendLinkController.onSend = function (ev) {
    ev.source.updateData();
    var data = ev.source.getBoundObject();
    this.view.longTask(function (done) {
        var records = [];
        data.recipient_ids.forEach((recipient_id) => {
            records.push({
                table: 'iz_link_send',
                action: 'insert',
                record: {
                    url: data.newLinkSend,
                    message: data.message,
                    user_id: recipient_id,
                    state: 'send'
                }
            });
        });
        this.api.db.transactionalChanges(records, function (err, savedRecords) {
            if (err) { return done(err); }
            done(null, savedRecords);
            this.view.close();
        }.bind(this));
    }.bind(this));
};

module.exports = notifySendLinkController;